import {
  AWSActionDetails,
  AWSResourceDetailsType,
  AWSResourceType,
  CRDAWSConfig,
} from './aws';
import {
  AzureActionDetails,
  AzureResourceDetailsType,
  AzureResourceType,
  CRDAzureConfig,
} from './azure';
import {
  CRDGCPConfig,
  GCPActionDetails,
  GcpResourceDetailsType,
  GCPResourceType,
} from './gcp';
import {
  CRDKubernetesConfig,
  KubernetesActionDetails,
  KubernetesResourceDetailsType,
  KubernetesNamespaceDetailsType,
  KubernetesResourceType,
} from './kubernetes';

export type CRDCloudService = 'aws' | 'kubernetes' | 'gcp' | 'azure';

export type CRDCloudConfig =
  | CRDAWSConfig
  | CRDKubernetesConfig
  | CRDGCPConfig
  | CRDAzureConfig;

export interface CRDResourceRequestBody {
  serviceType: CRDCloudService;
  resourceType: CRDResourceType;
  projectCode: string;
  cloudConfig: CRDCloudConfig;
  entityRef: string;
}

export type CRDResourceType =
  | AWSResourceType
  | GCPResourceType
  | AzureResourceType
  | KubernetesResourceType;

export interface CRDActionRequestBody {
  serviceType: CRDCloudService;
  details: ActionDetailsType;
  entityRef: string;
}

export interface CRDActionAllRequestBody {
  entityRef: string;
  aws?: AWSActionDetails[];
  kubernetes?: KubernetesActionDetails[];
  gcp?: GCPActionDetails[];
  azure?: AzureActionDetails[];
}

export interface ActionDetails {
  projectCode: string;
}

export interface ResourceDetails {
  identifier: string;
  name: string;
}

export type ActionDetailsType =
  | AWSActionDetails
  | GCPActionDetails
  | AzureActionDetails
  | KubernetesActionDetails;

export type ResourceDetailsType =
  | AWSResourceDetailsType
  | GcpResourceDetailsType
  | AzureResourceDetailsType
  | KubernetesResourceDetailsType;

export interface BaseResponse<T = void> {
  status?: 'success' | 'error'; // more strict typing
  error?: string; // error message if any
  response?: T; // success payload
}

export interface CRDProjectCodeConfig {
  project_code: string;
  aws?: CRDAWSConfig[];
  kubernetes?: CRDKubernetesConfig[];
  gcp?: CRDGCPConfig[];
  azure?: CRDAzureConfig[];
}

// Common response payload shape
export interface SuccessMessage {
  message: string;
}

// Specific responses

export type ListComputeResourceResponse = BaseResponse<ResourceDetailsType[]>;
export type GetKubernetesNamespacesResponse =
  BaseResponse<KubernetesNamespaceDetailsType>;

export type ExecuteActionResponse = BaseResponse<SuccessMessage>;

export enum ProjectCodeAction {
  START = 'start',
  STOP = 'stop',
  RESTART = 'restart',
}

export type ProjectCodeActionType =
  | ProjectCodeAction.START
  | ProjectCodeAction.STOP
  | ProjectCodeAction.RESTART;

export type ProjectCodeResourceType = 'all';
